module.exports = __webpack_public_path__ + "static/media/video-01-shelfzone.4789abc2.mp4";